import React from 'react';
import { bool, func, object } from 'prop-types';

import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';

import MeasurementSelect from './MeasurementSelect';
import defaultClasses from './ModifyRuleSensorModal.module.css';

const WeatherSourceFieldset = ({
    errors,
    hidden,
    onBlur,
    onPatch,
    touched,
    values
}) => {
    if (hidden) {
        return null;
    }

    return (
        <FormControl
            aria-labelledby="weather-sensor-label"
            className={defaultClasses.fieldset}
            role="group"
        >
            <FormLabel
                className={defaultClasses.legend}
                id="weather-sensor-label"
                focused={false}
            >
                Weather Sensor Options
            </FormLabel>
            <MeasurementSelect
                errors={errors}
                onBlur={onBlur}
                onPatch={onPatch}
                values={values}
                touched={touched}
            />
        </FormControl>
    );
};

WeatherSourceFieldset.propTypes = {
    hidden:   false,
    onBlur:   () => {},
    onPatch:  () => {},
    sensor:   {},
    validity: {}
};

WeatherSourceFieldset.propTypes = {
    errors:   object,
    hidden:   bool,
    onBlur:   func,
    onChange: func,
    onPatch:  func,
    touched:  object,
    values:   object
};

export default WeatherSourceFieldset;
